<template>
  <div class="home">
    <div style="background:#0076bf;height:30%;display:flex;justify-content: center;align-items: center;">
      <div>
        <van-image round width="100" height="100" :src="require('../../assets/top.png')"/>
        <p style="text-align:center;line-height:40px;color:#fff;ont-weight: bold;font-size: 20px;">{{userName}}</p>
      </div>
        
    </div>
    <van-cell title="修改密码" is-link @click="updatePwd()"/>
    <van-cell title="关于" is-link @click="about()"/>    
    <van-button style="width:90%;margin:30px auto;" block type="danger" @click="handleClick">退出</van-button>

    <van-popup v-model="isShow" position="right" get-container="body"  :style="{ height: '100%',width:'100%',background: '#f2f2f2' }" >
      <div style='height:12%;'>
        <van-nav-bar title="修改密码" left-text="返回" left-arrow @click-left="back"></van-nav-bar>
      </div>
        <div style='height:80%;overflow:auto;'>
          <van-cell-group>
            <van-field v-model="oldpwd" type="password" label="原始密码" placeholder="请输入原始密码" required/>
            <van-field v-model="newpwd" type="password" label="新设密码" placeholder="请输入新设密码" required/>
            <van-field v-model="confirmpwd" type="password" label="确认密码" placeholder="请输入确认密码" required/>
          </van-cell-group>       
          <van-button type="info" van-button style="width:90%;margin:20px auto" block @click="updateok()">提交</van-button>   
      </div>
    </van-popup>

    <van-popup closeable v-model="aboutShow" position="right" get-container="body"  :style="{ height: '100%',width:'100%'}" >
      <div style="margin-top: 20%;display: inline-block;text-align: center;">   
        <van-image width="30%" :src="require('../../assets/icon.png')" style="border-radius: 25%;margin-top: 15%;"/>
        <p style='margin-top: 30px;font-size: 16px;color: #000;font-family: PingFangSC-Regular, sans-serif;'>蚂蚁数据农场_V1.0</p>
      </div>
      <p style="position: absolute;bottom: 55px;width: 100%;text-align: center;font-family: PingFangSC-Regular, sans-serif;font-size: 14px;color: #8F8F94;">© 2019 jjr.com.cn,all rights reserved</p>
    </van-popup>

  </div>
</template>

<script>
// @ is an alias to /src
import { getUpPassword } from '@/request/data'
import { mapActions,mapState } from 'vuex'
export default {
  name: 'my',
  components: {
    
  },
  data() {
    return {
      isShow:false,
      aboutShow:false,
      oldpwd: '',
      newpwd: '',
      confirmpwd: '',
      dataInfo:{
        login_name:'',
        oldpwd:'',
        newpwd:'',
        confirmpwd:'',
      }
    }
  },
  mounted() {

  },
  computed: {
      ...mapState(['userName','token'])
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'home'
        })
      })
    },
    updatePwd(){
      this.isShow =true
      this.oldpwd =''
      this.newpwd =''
      this.confirmpwd =''
    },
    updateok(){
      if (this.oldpwd =='') { return this.$toast('原始密码不能为空'); }
      else if (this.newpwd =='') {return this.$toast('新设密码不能为空');}
      else if (this.confirmpwd =='') {return this.$toast('确认密码不能为空');}
      else if (this.newpwd != this.confirmpwd) {return this.$toast('两次输入的新密码不一致');}
      else{
        this.dataInfo.login_name= this.userName
        this.dataInfo.oldpwd= this.oldpwd
        this.dataInfo.newpwd= this.newpwd
        this.dataInfo.confirmpwd= this.confirmpwd

        getUpPassword(this.dataInfo).then(res=>{
          if (res.data.code == 0) {
            this.$toast(res.data.msg);
            this.isShow =false
          }else{
            this.$toast(res.data.msg.slice(11));
          }
        })
      }

    },
    about(){
      this.aboutShow =true
    },
    back(){
      this.isShow =false
    }
  },
}
</script>
